import { render, staticRenderFns } from "./qywxconfiguration.vue?vue&type=template&id=2acc4a2b&scoped=true"
import script from "./qywxconfiguration.vue?vue&type=script&lang=js"
export * from "./qywxconfiguration.vue?vue&type=script&lang=js"
import style0 from "./qywxconfiguration.vue?vue&type=style&index=0&id=2acc4a2b&prod&lang=less&scoped=true"
import style1 from "./qywxconfiguration.vue?vue&type=style&index=1&id=2acc4a2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acc4a2b",
  null
  
)

export default component.exports